import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const promptTemplateApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPromptTemplates: builder.query({
      query: filters => {
        const qs = Object.keys(filters || {}).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `prompt_template/?${qs}`;
      },
      providesTags: ['PromptTemplate'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPromptTemplatesQuery
} = promptTemplateApi;

